import { z } from 'zod';

export enum ProfessionSettingType {
	TEXT = 'text',
	ICON = 'icon',
}

// Schemas (source of truth)
export const professionDisplaySettingsSchema = z.object({
	trade: z.enum(ProfessionSettingType).optional(),
	specialty: z.literal(ProfessionSettingType.TEXT).optional(),
	contractor: z.literal(ProfessionSettingType.TEXT).optional(),
});

// Types (derived from schemas)
export type IProfessionDisplaySettings = z.infer<typeof professionDisplaySettingsSchema>;
